import { Link } from 'react-router-dom';
import CompanySelection from '../../component/CompanySelection/CompanySelection';
import { useCompany } from '../../component/CompanySelection/CompanyContext';
import './leftnav.css';
import logo from './ppm-logo.png';
import MenuItem from '../../component/Menu/MenuItem'
import CollapsibleMenu from '../../component/Menu/CollapsibleMenu';
import LoadingSpinner from '../../component/LoadingSpinner/LoadingSpinner';
import {
	multiPartyPaymentTypes,
	SINGLE_PARTY,
	MULTI_PARTY
} from '../../config/PaymentTypes';
import { createImageString } from '../../util/ImageUtil';
import { getUrl } from '../../util/EfupUtility';
import Has from '../../component/Permission/Has';
import { FF_ALL_PAYMENTS, FF_INDIVIDUAL_PAYMENTS, FF_MULTI_PARTY_PAYMENTS, FF_VENDOR_PAYMENTS, FF_USERS_PAGE, FF_ROLES_PAGE } from '../../config/FeatureFlagTypes';
import { U_VIEW_USERS, U_USER_ADMIN, ROLE_INTERNAL_U_USER_ADMIN, G_ADMIN_USER, REGISTER_COMPANIES } from '../../config/PermissionTypes';
import { toggleSidebar } from '../../component/Mobile/MobileHeader';
import { logoutRedirect } from '../../service/AuthService';

const LeftNav = props => {
	const VENDER_DISPLAY_CMPNY_FEAT = "InsightsDisplayVendorTab";

	const selectedCompany = useCompany();
	const { companyNumber, loadingDetails, companyFeaturesList } = selectedCompany;

	const companyHasPaymentType = requestedPaymentType => {
		// Determines if the company has any lienholder payment types

		if (!selectedCompany || !selectedCompany.programTypes || !companyFeaturesList) {
			return false;
		}

		// TODO: hidden until Lienholder payments is rescoped
		// if (requestedPaymentType === LIENHOLDER) {
		//     return selectedCompany.programTypes.some(paymentType => {
		//         return lienholderPaymentTypes.includes(paymentType.type)
		//     });
		// }

		// Determines if the company has any multi-party payment types
		if (requestedPaymentType === MULTI_PARTY) {
			return selectedCompany.programTypes.some(paymentType => {
				return multiPartyPaymentTypes.includes(paymentType.type)
			});
		}

		if (requestedPaymentType === VENDER_DISPLAY_CMPNY_FEAT) {
			let vendorDisplayCompanyFeature = companyFeaturesList.find((f) => f.name === VENDER_DISPLAY_CMPNY_FEAT);
			return vendorDisplayCompanyFeature ? vendorDisplayCompanyFeature.active : false;
		}

		// Iterate through the company's payment types, and return true the requested one was found
		return selectedCompany.programTypes.some(paymentType => paymentType.type === requestedPaymentType);
	}


	return (
		<div>
			<div className="sidebar-heading">
				<img src={logo} alt="Payment Portal Logo" />
				<i className="fa fa-arrow-left fa-2x white" onClick={() => toggleSidebar()}></i>
			</div>
			<div className="sidebar-company">
				<Link to={getUrl(companyNumber, '/dashboard')} style={{ textDecoration: 'none' }}>
					{selectedCompany && loadingDetails ?
						<LoadingSpinner size={50} testId='company-logo-loading-spinner' /> :
						<img src={createImageString(selectedCompany?.logo)} alt="Company Name Logo" data-testid="left-nav-company-logo" />
					}
					<p className='sidebar-company-name' data-testid="left-nav-selected-company-name">{selectedCompany?.companyName}</p>
				</Link>
				<CompanySelection />
			</div>
			<hr className="sidebar" />
			<nav className="nav" role="navigation">
				<ul className="nav__list">
					<MenuItem title="Dashboard" link={getUrl(companyNumber, '/dashboard')} />
					<CollapsibleMenu title="Payments">
						<Has featureFlag={FF_ALL_PAYMENTS}>
							<MenuItem title="All Payments" link={getUrl(companyNumber, '/payments')} />
						</Has>
						<Has featureFlag={FF_INDIVIDUAL_PAYMENTS}>
							{companyHasPaymentType(SINGLE_PARTY) &&
								<MenuItem title="Individual Payments" link={getUrl(companyNumber, '/payments/individual')} />
							}
						</Has>
						<Has featureFlag={FF_MULTI_PARTY_PAYMENTS}>
							{companyHasPaymentType(MULTI_PARTY) &&
								<CollapsibleMenu title="Multi-Party Payments" link={getUrl(companyNumber, '/payments/multiParty')} >
									{companyHasPaymentType(MULTI_PARTY) &&
										<MenuItem title="Multiple Claimants" link={getUrl(companyNumber, '/payments/multipleClaimants')} />
									}
									{companyHasPaymentType(MULTI_PARTY) &&
										<MenuItem title="Claimant(s) & Vendor" link={getUrl(companyNumber, '/payments/claimantAndVendor')} />
									}
								</CollapsibleMenu>
							}
						</Has>
						{/* <!-- TODO: hidden until lienholder payments is rescoped --> */}
						{/* { companyHasPaymentType(LIENHOLDER) &&
                            <MenuItem title="Lienholder Payments" link={getUrl(companyNumber, '/payments/lienholder')} />
                        } */}
						<Has featureFlag={FF_VENDOR_PAYMENTS}>
							{companyHasPaymentType(VENDER_DISPLAY_CMPNY_FEAT) &&
								<MenuItem title="Vendor Payments" link={getUrl(companyNumber, '/payments/vendor')} />
							}
						</Has>
					</CollapsibleMenu>
					{/* <!-- TODO: hidden until vendors are rescoped --> */}
					{/* <CollapsibleMenu title="Vendor" onExpand={()=>{navigate(getUrl(companyNumber, '/vendors'));}}>
                                <MenuItem title="Vendors" link={getUrl(companyNumber, '/vendors')}/>
                                <MenuItem title="Add New Vendor" link={getUrl(companyNumber, '/vendors/add')}/>
                                <MenuItem title="Issue Ad Hoc Payment" link={getUrl(companyNumber, '/vendors/issuePayment')}/>
                    </CollapsibleMenu> */}
					{/* <!-- TODO: hidden until reporting is rescoped --> */}
					{/* <CollapsibleMenu title="Reports" onExpand={()=>{navigate(getUrl(companyNumber, '/reports/mine'));}}>
                                <MenuItem title="My Reports" link={getUrl(companyNumber, '/reports/mine')}/>
                                <MenuItem title="Company Reports" link={getUrl(companyNumber, '/reports/company')}/>
                                <MenuItem title="Standard Reports" link={getUrl(companyNumber, '/reports/standard')}/>
                                <MenuItem title="Add New Custom Report" link={getUrl(companyNumber, '/reports/add')}/>
                    </CollapsibleMenu> */}
				</ul>
			</nav>
			<hr className="sidebar" />

			<nav className="nav" role="navigation">
				<ul className="nav__list">
					<Has featureFlag={[FF_USERS_PAGE, FF_ROLES_PAGE]} permission={[U_VIEW_USERS, U_USER_ADMIN]}>
						<CollapsibleMenu title="User Admin">
							<Has featureFlag={FF_USERS_PAGE}>
								<Has permission={U_VIEW_USERS}>
									<MenuItem title="Users" link={getUrl(companyNumber, '/users')} />
								</Has>
								<Has permission={U_USER_ADMIN}>
									<MenuItem title="Add New User" link={getUrl(companyNumber, '/users/add')} />
								</Has>
							</Has>
							<Has featureFlag={FF_ROLES_PAGE}>
								<Has permission={U_USER_ADMIN}>
									<MenuItem title="Roles" link={getUrl(companyNumber, '/roles')} />
								</Has>
								<Has permission={U_USER_ADMIN}>
									<MenuItem title="Create New Role" link={getUrl(companyNumber, '/roles/add')} />
								</Has>
							</Has>
						</CollapsibleMenu>
					</Has>

					<Has permission={ROLE_INTERNAL_U_USER_ADMIN}>
						<CollapsibleMenu title="System Admin">
							<Has permission={G_ADMIN_USER} >
								<MenuItem title="Feature Flags" link="/system/featureFlags" />
							</Has>
							<Has permission={REGISTER_COMPANIES} >
								<MenuItem title="Registered Companies" link="/system/registerCompanies" />
							</Has>
							<MenuItem title="Users" link="/system/users" />
							<MenuItem title="Internal Roles" link="/system/internalRoles" />
							<MenuItem title="Create Internal Role" link="/system/internalRoles/add" />
						</CollapsibleMenu>
					</Has>

					<li>
						<button data-testid="menu-item-log-out" onClick={logoutRedirect}>Log Out</button>
					</li>

				</ul>
			</nav>

		</div>
	);
}

export default LeftNav;
